import {getPaginationFromMeta} from '../utils/commonFunctions';

export default function usersReducer(state = {
  users: [],
  user: {attributes: {'security-questions': []}},
  outlets: [],
  editorInput: {},
  listInput: {},
  fetching: false,
  fetched: false,
  errors: {},
  paging: {
    number: 1,
    size: 20,
  },
}, action) {
  switch (action.type) {
    case 'GET_USER_LIST_PENDING':
    case 'GET_USER_PENDING': {
      return {...state, fetching: true, fetched: false};
    }
    case 'GET_USER_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        users: action.payLoad.data,
        listInput: {
          userGroups: action.payLoad.meta['user-groups'],
          statuses: action.payLoad.meta.statuses,
        },
        links: action.payLoad.links,
        paging: getPaginationFromMeta(state.paging, state.paging, action.payLoad.links)
      };
    }
    case 'GET_USER_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        user: action.payLoad.data,
        editorInput: action.payLoad.meta,
        saveLink: action.saveLink
      };
    }
    case 'INITIALIZE_ADD_USER_FULFILLED': {
      return {
        ...state,
        editorInput: {
          ...action.payLoad
        }
      };
    }
    case 'GET_USER_LIST_REJECTED':
    case 'GET_USER_REJECTED': {
      return {...state, errors: action.payLoad.errors};
    }
    case 'ADMIN_SAVE_SUCCESSFUL': {
      return {
        ...state,
        showWelcomePopup: true,
        user: {
          ...action.payLoad.data,
          attributes: {}
        },
      };
    }
    case 'WELCOME_EMAIL_SENT': {
      return {
        ...state,
        showWelcomePopup: false,
      };
    }
    case 'CLEAR_EDIT_USER': {
      return {
        ...state,
        user: {attributes: {'security-questions': []}},
      };
    }
    case 'PENDING_OUTLET_LINKED': {
      const { pendingOutletId: removedId, outlet } = action.payLoad;

      const pendingOutlets = state.user.relationships['pending-outlets'];
      const updatedPendingOutlets = pendingOutlets.data.filter(({ id }) => id !== removedId);

      return {
        ...state,
        user: {
          ...state.user,
          relationships: {
            ...state.user.relationships,
            outlets: {
              ...state.user.relationships.outlets,
              data: [...state.user.relationships.outlets.data, outlet],
            },
            'pending-outlets': {
              ...pendingOutlets,
              data: updatedPendingOutlets
            }
          }
        }
      };
    }
    case 'PENDING_OUTLET_REMOVED': {
      const { id: removedId } = action.payLoad;

      const pendingOutlets = state.user.relationships['pending-outlets'];

      if (!pendingOutlets) return state;

      const updatedPendingOutlets = pendingOutlets.data.filter(({ id }) => id !== removedId);

      return {
        ...state,
        user: {
          ...state.user,
          relationships: {
            ...state.user.relationships,
            'pending-outlets': {
              ...pendingOutlets,
              data: updatedPendingOutlets
            }
          }
        }
      };
    }
    default:
  }

  return {...state};
}
